import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const SunIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <circle cx="8" cy="8" r="4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      d="M8 4V1M10.9998 5.12132L13.1211 3M10.9998 10.9998L13.1211 13.1211M2.64626 13.1213L4.76758 11M2.99977 2.99977L5.12109 5.12109M8 15V12M12 8L15 8M1 8L4 8"
    />
  </svg>
));
